import React from "react";
import ProFilter from "../common/ProFilter";
import useCensus from "../../hooks/useCensus";
import "primeflex/primeflex.css";

const ProCensusFilter = ({ toggleFilter }) => {
    
    const { data:{ filter }, actions:{ SetFilter, ResetFilter } } = useCensus({ refreshTree: false });

     return <ProFilter filter={filter} toggleFilter={toggleFilter} SetFilter={SetFilter} ResetFilter={ResetFilter}/>
   
}

export default ProCensusFilter